import React from 'react'
import styles from './svg.module.scss'

const CircleDollarSign = ({
  viewBox = '0 0 24 24',
  size = 24,
  color = 'primaryColor',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={styles[`${color}Stroke`]}
      style={{ fill: 'none' }}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
      <path d="M12 18V6" />
    </svg>
  )
}

export default CircleDollarSign
